import { useLanguage } from '@/contexts/LanguageContext';

export function getPasswordStrength(password) {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[a-zA-Z]/.test(password) && /[0-9]/.test(password)) score++;
  if (/[^a-zA-Z0-9]/.test(password)) score++;
  return score;
}

export function isPasswordAcceptable(password) {
  return getPasswordStrength(password) >= 2;
}

export default function PasswordStrengthBar({ password }) {
  const { t } = useLanguage();
  if (!password) return null;

  const strength = getPasswordStrength(password);

  const levels = [
    { min: 0, label: t('password.weak') || 'Weak', color: 'bg-rose-500' },
    { min: 1, label: t('password.weak') || 'Weak', color: 'bg-rose-500' },
    { min: 2, label: t('password.medium') || 'Medium', color: 'bg-amber-400' },
    { min: 3, label: t('password.good') || 'Good', color: 'bg-blue-400' },
    { min: 4, label: t('password.strong') || 'Strong', color: 'bg-emerald-400' },
  ];

  const current = levels[Math.min(strength, 4)];

  return (
    <div className="space-y-1.5">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map(i => (
          <div
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-all duration-300 ${
              i <= strength ? current.color : 'bg-wp-dark/50'
            }`}
          />
        ))}
      </div>
      <p className={`text-xs ${
        strength <= 1 ? 'text-rose-400' :
        strength === 2 ? 'text-amber-400' :
        strength === 3 ? 'text-blue-400' : 'text-emerald-400'
      }`}>
        {current.label}
        {strength <= 1 && ` — ${t('password.hint') || 'min 8 chars, letters + numbers'}`}
      </p>
    </div>
  );
}
